import { Theme } from '@mui/material/styles';

import { BeforeInstallPromptEvent } from './before-install-prompt-event';

export interface INavigationSection {
  label: string;
  navigationLinks: NavigationLink[];
}

export interface NavigationLink {
  path: PathEnum;
  active: boolean;
  label: string;
  icon: JSX.Element;
  isShown: boolean;
  updatesCount?: number;
}

export interface NavigationItemProps {
  theme: Theme;
  $active?: boolean;
}

export interface SidebarProps {
  homePath: PathEnum;
  navigationSections: INavigationSection[];
  userName: string;
  userCompanyName: string;
  onNavigationLinkClick: (navigationLink: NavigationLink) => void;
  onUserProfileClick: () => void;
  onUserManagementClick: () => void;
  onLogoutClick: () => void;
  pwaInstallEvent: BeforeInstallPromptEvent | null;
}

export enum PathEnum {
  PATH_USER_SETTINGS = '/user/settings',
  PATH_LOGOUT = '/logout',
  PATH_TOUR_PLANNER = '/tour-planner',
  PATH_TOUR_PLANNER_CONFIGURATIONS = '/tour-planner/configurations',
  PATH_LOCATIONS = '/orders/locations',
  PATH_DASHBOARD = '/dashboard',
  PATH_CARRIER_NETWORK = '/carrier-network',
  PATH_RATE_MANAGEMENT = '/rate-management',
  PATH_LOADS = '/loads',
  PATH_VEHICLES = '/vehicles',
  PATH_SHIPMENT_EXECUTION = '/shipment-execution',
  PATH_DATA_EXPORT = '/data-export',
  PATH_ORDERS = '/orders',
  PATH_ORDER_PLANNING = '/order-planning',
  PATH_ARTICLES = '/orders/articles',
  PATH_ORDERS_LOADS = '/orders/loads',
  PATH_USER_MANAGEMENT = '/user-management',
  PATH_ANALYTICS = '/analytics',
  PATH_FLEETS = '/fleets',
}
